import { memo } from "react";

function CompletedMarker(props) {
  const {
    backgroundColor = "#05A792",
    borderColor = "white",
    size = 27,
  } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
        fill={backgroundColor}
      />
      <path
        d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
        stroke={borderColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.3 6.3V17.7H17.7V6.3H6.3ZM5 6C5 5.44771 5.44771 5 6 5H18C18.5523 5 19 5.44771 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44771 19 5 18.5523 5 18V6Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(CompletedMarker);
